<div class="orders-pager">
  <div class="orders-pager-sizes">
    <app-dropdown-list
      [ngModel]="pageSize()"
      styleClass="ng-select-sm"
      [canSelectMulti]="false"
      [items]="pageSizeOptions()"
      bindLabel="name"
      bindValue="id"
      [closeOnSelect]="true"
      [clearable]="false"
      (ngModelChange)="changePageSize($event)"
    >
    </app-dropdown-list>
  </div>

  <div class="orders-pager__pages">
    <span class="orders-pager__info-inline"
      >{{
        'orders.tablePaginationInfoText'
          | translate
            : { currentPage: currentPage(), pagesLength: totalPages(), dataLength: currentDataLength() }
      }}
    </span>
    @if(totalPages() > 1){
    <button
      mat-icon-button
      class="orders-pager__btn"
      (click)="goToPreviousPage()"
      [disabled]="currentPage() <= 1"
      aria-label="Précédent"
    >
      <mat-icon>chevron_left</mat-icon>
    </button>
    <div class="orders-pager__index">
      <input
        type="number"
        class="orders-pager__input no-arrows"
        [ngModel]="pageDraft()"
        (ngModelChange)="onPageInputChange($event)"
        (focus)="onPageInputFocus()"
        (blur)="commitPageInput()"
        (keydown.enter)="commitPageInput()"
        [min]="1"
        [max]="totalPages()"
        inputmode="numeric"
      />
    </div>
    <span class="orders-pager__sep ps-2">{{
      'orders.pageOf' | translate : { totalPages: this.totalPages() }
    }}</span>
    <button
      mat-icon-button
      class="orders-pager__btn"
      (click)="goToNextPage()"
      [disabled]="currentPage() >= totalPages()"
      aria-label="Suivant"
    >
      <mat-icon>chevron_right</mat-icon>
    </button>
    }
  </div>
</div>
